import { render, staticRenderFns } from "./FullDialog.vue?vue&type=template&id=2ee0cd52"
import script from "./FullDialog.vue?vue&type=script&lang=js"
export * from "./FullDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports